<table class="adminTable">
  <!--Table head-->
  <thead>
    <tr>
      <!-- Action Links Column -->
      <th></th>

      <th class="sortable-header" (click)="onSetSortClick('title')">
        Listing

        @if (sort === 'title') {
          <span>
            @if (!sortDescending) {
              <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
            }
            @if (sortDescending) {
              <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
            }
          </span>
        }
      </th>

      @if (showEmailColumn) {
        <th class="sortable-header" (click)="onSetSortClick('emailAddress')">
          Email Address
          @if (sort === 'emailAddress') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      }

      <th id="check-in-event-grid-name-header" class="sortable-header" title="Computed columns cannot be sorted." >Name</th>

      <th class="sortable-header" (click)="onSetSortClick('mobilePhone')">
        Mobile Phone

        @if (sort === 'mobilePhone') {
          <span>
            @if (!sortDescending) {
              <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
            }
            @if (sortDescending) {
              <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
            }
          </span>
        }
      </th>

      @if (isAdmin) {
        <th class="sortable-header" (click)="onSetSortClick('reservationId')">
          Reservation ID
          @if (sort === 'reservationId') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      }

      <th class="sortable-header" (click)="onSetSortClick('eventType')">
        Event Type

        @if (sort === 'eventType') {
          <span>
            @if (!sortDescending) {
              <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
            }
            @if (sortDescending) {
              <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
            }
          </span>
        }
      </th>

      <th class="sortable-header" (click)="onSetSortClick('timestamp')">
        Timestamp

        @if (sort === 'timestamp') {
          <span>
            @if (!sortDescending) {
              <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
            }
            @if (sortDescending) {
              <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
            }
          </span>
        }
      </th>

      @if (isAdmin && showComments) {
        <th class="sortable-header" (click)="onSetSortClick('comments')">
          Comments
          @if (sort === 'comments') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      }

      <!-- PK of CheckIn table -->
      @if (isAdmin) {
        <th class="sortable-header" (click)="onSetSortClick('checkInId')">
          CheckIn ID
          @if (sort === 'checkInId') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      }

      <!-- PK of CheckInOutEvent table -->
      @if (isAdmin) {
        <th class="sortable-header" (click)="onSetSortClick('Id')">
          CheckInOut Event ID
          @if (sort === 'id') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      }
    </tr>
  </thead>
  <!--Table head-->
  <!--Table body-->
  @if (rows && !retrieving) {
    <tbody>
      @for (r of rows; track r) {
        <tr (click)="onSingleClick($event, r)" (dblclick)="onDoubleClick($event, r)">
          <!-- Action Links Column -->
          <td>
            <!-- No Action Components At This Time -->
          </td>
          <td>
            <div (click)="onSingleClick(r)">
              {{ r.title }}
              <link-to-new-admin-listing [listingId]="r.listingId"></link-to-new-admin-listing>
            </div>
          </td>
          @if (showEmailColumn) {
            <td>
              <div class="email-cell" (click)="onSingleClick(r)">
                {{ r.emailAddress }}
                <!-- <link-to-user-account-detail [userAccountId]="r.userAccountId"></link-to-user-account-detail> -->
              </div>
            </td>
          }
          <td>
            <div (click)="onSingleClick(r)">
              {{ r.fullName }}
              <link-to-user-account-detail [openInNewTab]="true" [userAccountId]="r.userAccountId"></link-to-user-account-detail>
            </div>
          </td>
          <td>
            <div class="email-cell" (click)="onSingleClick(r)">
              {{ r.mobilePhone }}
              <!-- <link-to-user-account-detail [userAccountId]="r.userAccountId"></link-to-user-account-detail> -->
            </div>
          </td>
          @if (isAdmin) {
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.reservationId }} <link-to-booking-detail [bookingId]="r.bookingId"></link-to-booking-detail>
              </div>
            </td>
          }
          <td>
            <div (click)="onSingleClick(r)">
              {{ r.eventType }}
            </div>
          </td>
          <td>
            <div (click)="onSingleClick(r)">
              <div class="date-cell-display">
                <!-- https://angular.io/api/common/DatePipe -->
                {{ r.timestamp | date: "EEE, MMM d, y, h:mm a":"offset" }}
              </div>
            </div>
          </td>
          @if (isAdmin && showComments) {
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.comments }}
              </div>
            </td>
          }
          @if (isAdmin) {
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.checkInId }}
              </div>
            </td>
          }
          @if (isAdmin) {
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.id }}
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  }
  <!--Table body-->
</table>
